import { 
    Text,
    Image,
    ListItem,
    UnorderedList, 
} from '@chakra-ui/react'
import React from 'react'

import Carousel from './Carousel'

type props = {
    type: string;
    content: string;
    index?: number;
    align?: 'center' | 'left' | 'right' | 'justify' | 'inherit' | 'initial' | 'revert' | 'unset' | undefined;
    listElements?: string[];
}

const TextContentAbout = ({type, content, index, listElements, align} : props) => {
    if (align === undefined) {
        align = 'center'
    }
  return (
    <>
        {
            type === 'subTitle' &&
            <Text
                maxW={'900px'}
                fontSize={{ base: '2xl', md: '4xl' }}
                textAlign= {align}
                fontWeight={'bold'}
                fontFamily={'body'}
                lineHeight={'1.15'}
                key={index}
                >

                {content}
            </Text>
        }
        {
            type === 'image' &&
            <Image src={content} 
                borderRadius={{ base: '18px', md: '24px' }}
                alt={'picture'}
                width={'100%'}
                maxW={'980px'}
                fit={'cover'}
                align={align}
                height={{base:'300px',md:'480px'}}
                margin={'auto'}
                objectPosition={'center'}
                >
            </Image>
        }
        {
            type === 'carousel' &&
            <Carousel 
                images={listElements || []}
                height={{ base: '58vh', md: '48vh' }}
            />
        }
        {
            type === 'content' &&
            <Text
                maxW={'900px'}
                textAlign={align}
                fontSize={{ base: 'lg', md: 'xl' }}
                fontWeight={'normal'}
                fontFamily={'body'}
                lineHeight={'1.7'}
                key={index}
                >
                {content}
            </Text>
        }
        {
            type === 'list' && 
            <>
            <Text
                maxW={'900px'}
                fontSize={{ base: '2xl', md: '4xl' }}
                textAlign={align}
                fontWeight={'bold'}
                fontFamily={'body'}
                key={index}
                paddingTop={{ base: 2, md: 4 }}
                >
                {content}
            </Text>
            <UnorderedList spacing={3}
                margin={'0 auto'}
                maxW={'900px'}
                padding={'0 2vw 2vh 3vw'}
                textAlign="left">
                {
                    listElements?.map((item, index) => {
                        return (
                                <ListItem
                                    fontSize={{ base: 'lg', md: 'xl' }}
                                    fontWeight={'normal'}
                                    fontFamily={'body'}
                                    lineHeight={'1.6'}
                                    key={index}
                                    >
                                    {item}
                                </ListItem>
                        )
                    })
                }
            </UnorderedList>
            </>
        }
    </>
  )
}

export default TextContentAbout
